export default __webpack_public_path__ + "static/media/flo-energy-bg.1e6011b4.jpeg";